import styles from './ProductCardSpecials.module.scss';
import { Content, FontAwesomeProIcon, Modal } from '@wienenergiegithub/ui-next';
import { useDialogStore, DialogDisclosure } from '@ariakit/react';
import React from 'react';
import classNames from 'classnames';

const ProductCardSpecialsLegacy = ({
  items,
  multiplePrices,
  okoDisclaimer,
  title,
  okoShow,
  fixHeight,
}) => {
  const ecoDialog = useDialogStore();
  const isreducedSpecial = title?.includes('Tanke') && items?.length < 3;
  return (
    <div>
      <ul
        className={classNames('ProductCardList-equal-height', styles.specials, {
          [styles.reduced]: multiplePrices,
          [styles.reducedSpecial]: isreducedSpecial,
          [styles.okoShowSpecial]: okoShow,
          [styles.fixHeight]: fixHeight,
        })}
      >
        {items.map(item => (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          <li className={styles.specialItem} key={item} tabIndex={0}>
            <div className={styles.checkbox}>
              <FontAwesomeProIcon
                icon="check"
                role="presentation"
                type="regular"
              />
            </div>
            <div>{item}</div>
          </li>
        ))}
        {okoShow && (
          <li className={styles.specialItem}>
            <div className={styles.checkbox}>
              <FontAwesomeProIcon
                icon="check"
                role="presentation"
                type="regular"
              />
            </div>
            <div>Als Öko-Tarif verfügbar</div>
            <DialogDisclosure
              className={styles.informationButton}
              store={ecoDialog}
            >
              <span className={styles.iconWrapper}>
                <FontAwesomeProIcon
                  className={styles.priceMoreIcon}
                  fixedWidth
                  icon="info-circle"
                  role="presentation"
                  type="regular"
                />
              </span>
            </DialogDisclosure>
          </li>
        )}
      </ul>
      <Modal header={`${title} auch als Öko-Tarif möglich`} store={ecoDialog}>
        <Content tabIndex={0} withParser>
          {okoDisclaimer}
        </Content>
      </Modal>
    </div>
  );
};

export default ProductCardSpecialsLegacy;
